import useSession from '../../hooks/useSession';
import { Link } from 'react-router-dom'
import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
const Landing = () => {
  const [session] = useSession()
  const { user } = useContext(UserContext)

  const getButtonByRole = (role) => {
    switch (role) {
      case 'am':
        return <Link className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" to="/magic-link">Create a project</Link>
      case 'admin':
        return <Link className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800" to="/register">Create account manager</Link>  
      default:
        return '';
    }
  }

  return (
    <section className="container mx-auto px-4">
      <div className="text-center">
        <div className="landing-inner">
          <h1 className="text-6xl dark:text-white mb-6">Bunny widget</h1>
          <p className="text-4xl dark:text-white mb-6">
            This is a test as a user of the bunny widget
          </p>
          <div>
            {session && user ?
              (getButtonByRole(user.position)) :
              (<>
                <Link className="py-2.5 px-5 mr-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" to="/login">Login</Link>
              </>)
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default Landing